import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator'
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { tag } from '../../../../model/tag';

export interface IActions {
    deleteTag: (tag: tag) => void;
    editTag: (tag: tag) => any;
    saveTag: (tag: tag) => any;
    updateTag: (tag: tag) => any;
    loadTag: (id: string) => void,
    loadTags: () => Promise<Array<tag>>,
    clearSelection: () => void,
    print: (tagIds: string[]) => any;
    download: (tagIds: string[]) => any;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadTags: () => {
            return new Promise((res, rej) => dispatch({
                type: Keys.LOADTAGS,
                payload: invokeApi({
                    path: '/api/Tags',
                    method: 'GET',
                    responseType: 'json'
                }).then(resp =>{
                    res(resp);
                    return resp;
                })
            }))
        },
        deleteTag: (tag: tag) => {
            dispatch({
                type: Keys.DELETETAG,
                payload: invokeApi({
                    path: '/api/Tags/' + tag.code,
                    method: 'DELETE',
                    responseType: 'json'
                })
            })
        },
        saveTag: (tag: tag) => {
            dispatch({
                type: Keys.SAVETAG,
                payload: invokeApi({
                    path: '/api/Tags',
                    method: 'POST',
                    body: tag,
                    responseType: 'json'
                })
            })
        },
        editTag: (tag: tag) => {
            dispatch({
                type: Keys.EDITTAG,
                payload: tag
            })
        },
        clearSelection: () => {
            dispatch({
                type: Keys.CLEARSELECTION
            })
        },
        loadTag: (id: string) => {
            dispatch({
                type: Keys.LOADTAG,
                payload: invokeApi({
                    path: '/api/Tags/' + id,
                    method: 'GET',
                    responseType: 'json'
                }),
            })
        },
        updateTag: (tag: tag) => {
            dispatch({
                type: Keys.UPDATETAG,
                payload: tag
            })
        },
        print: (tagIds: string[]) => {
            dispatch({
                type: Keys.PRINT,
                payload: invokeApi({
                    path: '/api/Tags/print',
                    method: 'POST',
                    body:tagIds,
                    responseType: 'json'
                }),
            })
        },
        download: (tagIds: string[]) => {
            dispatch({
                type: Keys.DOWNLOAD,
                payload: invokeApi({
                    path: '/api/Tags/download',
                    method: 'POST',
                    body:tagIds,
                    responseType: 'json'
                }),
            })
        },
    }
}